var map = {
	"./bulb.svg": "./src/assets/img/loss-analysis-setup-img/bulb.svg",
	"./check.svg": "./src/assets/img/loss-analysis-setup-img/check.svg",
	"./chf-flag.svg": "./src/assets/img/loss-analysis-setup-img/chf-flag.svg",
	"./country/aud-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/aud-flag.svg",
	"./country/cad-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/cad-flag.svg",
	"./country/cny-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/cny-flag.svg",
	"./country/hkd-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/hkd-flag.svg",
	"./country/inr-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/inr-flag.svg",
	"./country/jpy-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/jpy-flag.svg",
	"./country/pln-flag.svg": "./src/assets/img/loss-analysis-setup-img/country/pln-flag.svg",
	"./ddl-search.svg": "./src/assets/img/loss-analysis-setup-img/ddl-search.svg",
	"./delete-icon.svg": "./src/assets/img/loss-analysis-setup-img/delete-icon.svg",
	"./disable-process-three.svg": "./src/assets/img/loss-analysis-setup-img/disable-process-three.svg",
	"./disable-process-two.svg": "./src/assets/img/loss-analysis-setup-img/disable-process-two.svg",
	"./done-chk-white.svg": "./src/assets/img/loss-analysis-setup-img/done-chk-white.svg",
	"./drag.svg": "./src/assets/img/loss-analysis-setup-img/drag.svg",
	"./eur-flag.svg": "./src/assets/img/loss-analysis-setup-img/eur-flag.svg",
	"./first-open-process.svg": "./src/assets/img/loss-analysis-setup-img/first-open-process.svg",
	"./gbp-flag.svg": "./src/assets/img/loss-analysis-setup-img/gbp-flag.svg",
	"./usd-flag.svg": "./src/assets/img/loss-analysis-setup-img/usd-flag.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/loss-analysis-setup-img sync recursive ^\\.\\/.*$";